import { useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AppLayout } from "./components/shared/app-layout";
import { ProtectedRoute } from "./components/shared/protected-route";
import { useTheme } from "./hooks/use-theme";
import { logout } from "./lib/logout";
import { AnalyticsDashboardPage } from "./pages/analytics-dashboard-page";
import { BackofficePage } from "./pages/backoffice-page";
import { BackofficeUsersPage } from "./pages/backoffice-users-page";
import { BrandPerformancePage } from "./pages/brand-performance-page";
import { CampaignDetailsPage } from "./pages/campaign-details-page";
import { CampaignsPage } from "./pages/campaigns-page";
import { NewCampaignPage } from "./pages/new-campaign-page";
import { LoginPage } from "./pages/sso/login-page";
import { CallbackPage } from "./pages/sso/callback-page";
import { LoggedOutPage } from "./pages/sso/logged-out-page";
import { AppToaster } from "./components/app-toaster";

function App() {
  const { theme, resolvedTheme, setTheme } = useTheme();
  const [currentStepLabel, setCurrentStepLabel] = useState("Brand");

  return (
    <>
      <AppToaster />
      <Routes>
        <Route path="/sso/login" element={<LoginPage />} />
        <Route path="/sso/callback" element={<CallbackPage />} />
        <Route path="/sso/logged-out" element={<LoggedOutPage />} />
        <Route
          path="/backoffice"
          element={
            <ProtectedRoute>
              <AppLayout
                currentPageLabel="Brands"
                sidebarVariant="backoffice"
                onLogout={logout}
                theme={theme}
                onThemeChange={setTheme}
              >
                <BackofficePage />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/backoffice/users"
          element={
            <ProtectedRoute>
              <AppLayout
                currentPageLabel="Users"
                sidebarVariant="backoffice"
                onLogout={logout}
                theme={theme}
                onThemeChange={setTheme}
              >
                <BackofficeUsersPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/campaigns"
          element={
            <ProtectedRoute>
              <AppLayout
                currentPageLabel="Campaigns"
                onLogout={logout}
                theme={theme}
                onThemeChange={setTheme}
              >
                <CampaignsPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/campaigns/:campaignId"
          element={
            <ProtectedRoute>
              <AppLayout
                currentPageLabel="Campaign details"
                onLogout={logout}
                theme={theme}
                onThemeChange={setTheme}
              >
                <CampaignDetailsPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/analytics"
          element={
            <ProtectedRoute>
              <AppLayout
                currentPageLabel="Analytics"
                onLogout={logout}
                theme={theme}
                onThemeChange={setTheme}
              >
                <AnalyticsDashboardPage theme={resolvedTheme} />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/brand-performance"
          element={
            <ProtectedRoute>
              <AppLayout
                currentPageLabel="Brand Performance"
                onLogout={logout}
                theme={theme}
                onThemeChange={setTheme}
              >
                <BrandPerformancePage theme={resolvedTheme} />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/campaigns/new"
          element={
            <ProtectedRoute>
              <AppLayout
                currentPageLabel="New campaign"
                currentStepLabel={currentStepLabel}
                onLogout={logout}
                theme={theme}
                onThemeChange={setTheme}
              >
                <NewCampaignPage onStepLabelChange={setCurrentStepLabel} />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/campaigns" replace />} />
      </Routes>
    </>
  );
}

export default App;
